import { render, staticRenderFns } from "./MaterialCreativeAdd.vue?vue&type=template&id=fc05e4a4&scoped=true&"
import script from "./MaterialCreativeAdd.vue?vue&type=script&lang=js&"
export * from "./MaterialCreativeAdd.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCreativeAdd.vue?vue&type=style&index=0&id=fc05e4a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc05e4a4",
  null
  
)

export default component.exports